import { render } from "./TestResultGuideForBookProduct.vue?vue&type=template&id=4a10c25b&scoped=true"
import script from "./TestResultGuideForBookProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForBookProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForBookProduct.vue?vue&type=style&index=0&id=4a10c25b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a10c25b"]])

export default __exports__